import { bl_fi_pricing_scheme_link_update_queue_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class PricingSchemeLinkUpdateQueueContainerModel extends BaseContainerModel {
  bl_fi_pricing_scheme_link_update_queue: bl_fi_pricing_scheme_link_update_queue_RowClass = new bl_fi_pricing_scheme_link_update_queue_RowClass();
}

